<template lang="pug">
#base-header
    .view-container
        .base-container
            .base-title-container
                h1.base__title
                    i.voltar.mdi.mdi-arrow-left-thick(
                        v-if='voltarPara',
                        @click='irParaRota(voltarPara)'
                    )
                    | {{ titulo }}
                .base__breadcrumb(v-if='breadcrumb')
                    el-breadcrumb(separator-class=".el-breadcrumb__separator")
                        el-breadcrumb-item(
                            v-for='(sub, index) in breadcrumb',
                            :key='index'
                        )
                            span.link-breadcrumb(@click='irParaRota(sub)')
                                | {{ sub.nome }}
            el-tooltip(v-if="tooltip", placement='bottom')
                div(slot="content", style="max-width: 200px;text-align: justify;") {{ tooltip }}
                .base-button-container
                    slot(name='direita')
                    BaseButton.base-button-container__btn(
                        type='primary',
                        :icon='icon',
                        v-if='exibeBotao',
                        :disabled='desabilitaBotao',
                        :loading='loading',
                        @click='emit()'
                    )
                        | {{ btnTexto }}
            .base-button-container(v-else)
                slot(name='direita')
                BaseButton.base-button-container__btn(
                    type='primary',
                    :icon='icon',
                    v-if='exibeBotao',
                    :disabled='desabilitaBotao',
                    :loading='loading',
                    @click='emit()'
                )
                    | {{ btnTexto }}
</template>

<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
// IMPORTANTE !! Utilize a classe .view-container-base-header para complementar o uso desse componente.
import { mapActions, mapState } from 'vuex';
export default {
    name: 'BaseHeader',
    components: {
        BaseButton
    },
    emits: ['btnHeaderClicado', 'mudar-de-rota'],
    props: {
        titulo: {
            type: String,
            default: () => ''
        },
        voltarPara: {
            type: [Object, Boolean, String],
            default: () => null
        },
        breadcrumb: {
            type: Array,
            default: () => []
        },
        btnTexto: {
            type: String,
            default: () => ''
        },
        icon: {
            type: String,
            default: () => ''
        },
        exibeBotao: {
            type: Boolean,
            default: false
        },
        desabilitaBotao: {
            type: Boolean,
            default: false
        },
        tooltip: {
            type: String,
            default: () => null
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState({
            filtroState: state => state.filtroInteligenciaTerritorial
        })
    },
    methods: {
        ...mapActions(['setFiltroInteligenciaTerritorial']),
        irParaRota(rota) {
            if (rota.nome === this.$t('mensagens.inteligenciaTerritorial.visaoGeral')) {
                let filtros = {
                    tipoAgrupamento: 'PAIS',
                    possuiRestricao: null
                };
                this.setFiltroInteligenciaTerritorial(filtros);
            } else if (rota.nome === 'Estado') {
                let filtros = {
                    ...this.filtroState,
                    tipoAgrupamento: 'ESTADO'
                };
                this.setFiltroInteligenciaTerritorial(filtros);
            } else if (rota.nome === 'Município') {
                let filtros = {
                    ...this.filtroState,
                    tipoAgrupamento: 'MUNICIPIO'
                };
                this.setFiltroInteligenciaTerritorial(filtros);
            }
            if (!rota) return;
            if (typeof rota === 'boolean' && rota) {
                this.$router.go(-1);
            } else if (typeof rota.rota === 'string' && rota.rota === 'emit') {
                this.$emit('voltarClicado');
            } else if (this.$route.path !== rota.rota) {
                this.$router.push({ path: rota.rota });
                this.$emit('mudar-de-rota', rota);
            }
        },
        emit() {
            this.$emit('btnHeaderClicado');
        }
    }
};
</script>

<style lang="scss">
#base-header {
    background: var(--white);
    box-shadow: 0 1px 3px 0 var(--block-shadow);
    .base-container {
        width: 100%;
        min-height: 87px;
        background: var(--white);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .base__title {
            display: flex;
            align-items: center;
            .voltar {
                cursor: pointer;
                font-size: 27px;
                color: #303133;
            }
            .voltar:hover {
                color: var(--secondary);
            }
        }
        .base-title-container {
            display: flex;
            flex-direction: column;
            .base__title {
                font-weight: 600;
            }
            .base__breadcrumb {
                margin-top: 8px;
                .el-breadcrumb__separator {
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                    display: inline-flex;
                    margin: 0 15px 0px 15px;
                    background-color: var(--gray);
                }
                span.link-breadcrumb {
                    color: #1989fa;
                    text-decoration: underline;
                    cursor: pointer;
                }
                span.link-breadcrumb:hover {
                    color: var(--secondary);
                }
                .el-breadcrumb__item:last-child .el-breadcrumb__separator {
                    display: none;
                }
            }
        }
    }
    .button-outline {
        border-color: var(--secondary-two) !important;
        color: var(--white) !important;
        background: var(--secondary-two) !important;
    }
    .base-button-container__btn {
        span {
            margin-left: 5px;
        }
    }
}
</style>
